import React from 'react'
import { Alert, Container, Row, Col } from 'reactstrap'
import qs from 'query-string';
import {post} from 'axios'      
const EmployerAction = ({location}) => {
    const color = atob(qs.parse(location.search).a).split('?')[1] == 5 ? 'success' : 'danger';
    post('/api/loanAction/' + atob(qs.parse(location.search).a).split('?')[1] , {
        note: atob(qs.parse(location.search).a).split('?')[1] == 5 ? 'Loan was Approved' : 'Loan was Rejected' + ' by Recruiter due to invalid information', _id: atob(qs.parse(location.search).a).split('?')[0],
    }).then(({ data }) => {
            console.log(data)
        }).catch(({ response }) => {
            console.log(response)
        })
    return (
                
                <Container>
                <Row style={{height: '100vh'}} className="align-items-center">
                    <Col md={12}>
            <Alert className="text-center" color={color}>
            <h4 className="alert-heading">{atob(qs.parse(location.search).a).split('?')[2]}</h4>
            <p>
              Loan was {color == 'success' ? 'Approved' : 'rejected'} successfully
            </p>
            <hr />
            <p className="mb-0">
              Thank you
            </p>
          </Alert></Col></Row>
          </Container>
            );
        };
        
        export default EmployerAction;

